import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
import { portalContentMaxWidthSx, portalPageHorizontalPaddingSx } from '../../../theme/portalLayout';
/**
 * Breadcrumb – trail of links (e.g. OneStop > Departments > Secretary of State).
 */
const Breadcrumb = ({ label, gradient, items = [], separator, paddingTop, paddingBottom, marginTop, marginBottom, maxWidth, fontSize, fontFamily, componentAlignment = 'left', }) => {
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : 'transparent';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 2,
            paddingBottom: paddingBottom || 2,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: {
                ...portalContentMaxWidthSx,
                ...(maxWidth != null ? { maxWidth } : {}),
                ...portalPageHorizontalPaddingSx,
            }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 1, color: 'text.secondary', letterSpacing: 1 }, children: label })), _jsx(Box, { sx: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: 0.5,
                        fontSize: fontSize || '0.875rem',
                        fontFamily: fontFamily || undefined,
                        color: 'text.secondary',
                    }, children: items.map((item, index) => {
                        const isLast = index === items.length - 1;
                        return (_jsxs(React.Fragment, { children: [index > 0 && (_jsx(Box, { component: "span", sx: { display: 'flex', alignItems: 'center', color: 'text.disabled' }, children: separator === 'custom' ? null : separator || _jsx(NavigateNextIcon, { sx: { fontSize: 18 } }) })), isLast || !item.href ? (_jsx(Typography, { component: "span", sx: { fontWeight: isLast ? 600 : 400, color: isLast ? 'text.primary' : 'inherit' }, children: item.label })) : (_jsx(Link, { href: item.href, underline: "hover", sx: { color: 'primary.main' }, children: item.label }))] }, index));
                    }) })] }) }));
};
export default Breadcrumb;
